/**
 * KeyGate.js
 *
 * Asks for the staff or admin key once. The page checks it with the backend and remembers it on this device.
 */

import React, { useState } from "react";
import { KeyRound } from "lucide-react";

const PAPER = "#FBF7EF";
const INK = "#1B2A41";
const MUTED = "#5B6577";

/**
 * @param {String} title        -   e.g. 'Check-in counter'
 * @param {String} label        -   e.g. 'Staff key'
 * @param {String} error        -   Shown under the field, e.g. after a wrong key
 * @param {Function} onSubmit   -   Called with the key
 * @returns {JSX.Element}
 */
const KeyGate = ({ title, label, error, onSubmit }) => {
    const [key, setKey] = useState("");
    return (
        <form
            onSubmit={(e) => { e.preventDefault(); if (key.trim()) onSubmit(key.trim()); }}
            className="w-full max-w-sm mx-auto mt-24 rounded-[22px] overflow-hidden text-center"
            style={{ background: PAPER, boxShadow: "0 10px 30px rgba(27,42,65,0.18)" }}
        >
            <div className="py-4 text-sm font-bold tracking-[0.24em]" style={{ background: INK, color: PAPER }}>RIGHT BROTHER AIRWAYS</div>
            <div className="px-5 py-7 flex flex-col items-center gap-4">
                <KeyRound size={32} color={INK} aria-hidden="true" />
                <h1 className="text-xl font-bold tracking-[0.14em] uppercase">{title}</h1>
                <input
                    type="password"
                    value={key}
                    onChange={(e) => setKey(e.target.value)}
                    placeholder={label}
                    aria-label={label}
                    autoComplete="current-password"
                    className="w-full rounded-lg border px-3 py-2.5 bg-white text-base focus:outline-none focus:ring-2"
                    style={{ borderColor: "#C9C2B4", "--tw-ring-color": INK }}
                />
                {error && <p role="alert" className="text-sm" style={{ color: "#A8183D" }}>{error}</p>}
                <button type="submit" className="w-full rounded-full px-6 py-3 text-sm font-bold tracking-[0.18em]" style={{ background: INK, color: PAPER }}>
                    UNLOCK
                </button>
                <p className="text-xs" style={{ color: MUTED }}>Remembered on this device.</p>
            </div>
        </form>
    );
};

export default KeyGate;
